<template>
  <Modal
    class="cc-modal"
    width="600"
    footer-hide
    v-model="visibility"
    title="添加域名解析"
  >
    <div class="content">
      <loading class="fixed" :loading="loading" style="z-index: 11"></loading>
      <div class="section">
        <div class="col">
          <div class="name required">主机记录：</div>
          <div class="label row">
            <Input
              class="height45"
              v-model.trim="form.host"
              placeholder="请输入主机记录"
              style="width: 200px"
              clearable
            />
            <div style="margin-left: 20px">{{ $route.query.domainName }}</div>
          </div>
        </div>
        <div class="col">
          <div class="name required">记录类型：</div>
          <div class="row">
            <Select
              class="height45"
              v-model="form.type"
              filterable
              transfer
              style="width: 200px"
            >
              <Option
                v-for="(item, index) in typeList"
                :key="'p' + index"
                :value="item.type"
                >{{ item.type }}</Option
              >
            </Select>
            <div style="margin-left: 20px">{{ desc }}</div>
          </div>
        </div>
        <div class="col">
          <div class="name required">线路类型：</div>
          <Select
            class="height45"
            v-model="form.lineId"
            filterable
            transfer
            style="width: 200px"
          >
            <Option
              v-for="(item, index) in routeList"
              :key="'p' + index"
              :value="item.lienId"
              >{{ item.lineName }}</Option
            >
          </Select>
        </div>
        <div class="col">
          <div class="name required">记录值：</div>
          <Input
            class="height45"
            v-model="form.value"
            placeholder="请输入记录值"
            style="width: 200px"
            clearable
          />
        </div>
        <div class="col">
          <div class="name required">MX优先级：</div>
          <div class="row">
            <Input
              class="height45"
              v-model="form.mx"
              @on-keyup="onKeyupMX"
              @on-blur="onBlurpMX"
              placeholder="请输入MX优先级"
              style="width: 200px"
              clearable
            />
            <div style="margin-left: 20px">MX优先级范围1-20</div>
          </div>
        </div>
        <div class="col">
          <div class="name required">TLL：</div>
          <div class="row">
            <Input
              class="height45"
              v-model="form.ttl"
              @on-keyup="onKeyupTTL"
              @on-blur="onBlurpTTL"
              placeholder="请输入TLL"
              style="width: 200px"
              clearable
            />
            <div style="margin-left: 20px">TLL范围600-604800</div>
          </div>
        </div>
        <div class="col">
          <div class="name">手机号码：</div>
          <div class="row">
            <Input
              class="height45"
              v-model="user.phoneNumber"
              disabled
              style="width: 200px"
              clearable
            />
            <div style="margin-left: 20px">
              <smsBtn
                ref="smsBtn"
                height="45px"
                shape=""
                @tap="getCodeEvent"
                style="width: 120px; margin-left: 30px"
              ></smsBtn>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="name" style="color: #f9521f">
            若手机号已停用无法收到短信，请联系在线客服!
          </div>
        </div>
        <div class="col">
          <div class="name required">短信验证码：</div>
          <div class="row">
            <Input
              class="height45"
              v-model="form.code"
              placeholder="请输入短信验证码"
              style="width: 200px"
              @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
              clearable
            />
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <Button
        :loading="loading"
        @click="onConfirm"
        type="primary"
        style="margin-right: 20px"
        >确定</Button
      >
      <Button @click="onCancel">取消</Button>
    </div>
  </Modal>
</template>
<script>
import {
  resolutionGetRoute,
  smsSend,
  resolutionSave,
  resolutionModify,
} from "api/customer.js";
import { mapState } from "vuex";
import loading from "components/loading.vue";
import smsBtn from "components/smsBtn.vue";
export default {
  name: "addBackModal",
  components: {
    loading,
    smsBtn,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
      default: 0, // 0 保存 1 修改
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {
        code: "",
        domainId: "",
        host: "",
        lineId: "", // 线路类型
        mx: "",
        remark: "",
        ttl: "",
        type: "",
        value: "",
      },
      typeList: [], // 记录类型数据
      routeList: [], // 线路数据
      loading: false,
    };
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val) {
        if (this.type === 1 && val) {
          this.form.id = val.id;
          this.form.host = val.host;
          this.form.lineId = val.routeId;
          this.form.mx = val.mxValue;
          this.form.remark = val.remark;
          this.form.ttl = val.ttl;
          this.form.type = val.type;
          this.form.value = val.value;
        }
      },
    },
  },
  computed: {
    ...mapState(["user"]),
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
    desc() {
      if (this.typeList.length === 0) {
        return "";
      }
      if (!this.form.type) {
        return "";
      }
      const data = this.typeList.filter((o) => {
        return this.form.type === o.type;
      });
      return data[0].desc;
    },
  },
  async mounted() {
    this.req_resolutionGetRoute();
  },
  methods: {
    // 获取验证码
    getCodeEvent(callback) {
      smsSend()
        .then((res) => {
          if (res.code === 200 && res.result) {
            callback(true);
          }
        })
        .catch(() => {
          this.$refs.smsBtn.reset();
        });
    },
    // 获取记录类型、线路
    async req_resolutionGetRoute() {
      try {
        const { code, data } = await resolutionGetRoute();
        if (code === 200 && data) {
          this.routeList = data.routeList;
          this.routeList.length > 0 &&
            (this.form.lineId = this.routeList[0].lienId);
          this.typeList = data.typeList;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 取消添加
    onCancel() {
      this.form = this.$options.data().form;
      this.visibility = false;
    },
    // mx输入框只能输入数字
    onKeyupMX() {
      this.form.mx = this.form.mx.replace(/[^\d]/g, "");
    },
    // MX输入框优先级范围
    onBlurpMX() {
      if (this.form.mx) {
        if (parseInt(this.form.mx) <= 0 || parseInt(this.form.mx) > 20) {
          this.$Message.warning("MX优先级范围1-20");
          return false;
        }
      }
    },
    // TTL输入框只能输入数字
    onKeyupTTL() {
      this.form.ttl = this.form.ttl.replace(/[^\d]/g, "");
    },
    // TTL输入框优先级范围
    onBlurpTTL() {
      if (parseInt(this.form.ttl) <= 600 || parseInt(this.form.ttl) > 604800) {
        this.$Message.warning("TLL范围600-604800");
        return false;
      }
    },
    // 确认提交
    async onConfirm() {
      if (!this.form.host) {
        this.$Message.warning("请输入主机记录！");
        return;
      }
      if (!this.form.type) {
        this.$Message.warning("请输入记录类型！");
        return;
      }
      if (!this.form.lineId) {
        this.$Message.warning("请输入线路类型！");
        return;
      }
      if (!this.form.value) {
        this.$Message.warning("请输入记录值！");
        return;
      }
      if (!this.form.mx) {
        this.$Message.warning("请输入MX优先级！");
        return;
      }
      if (this.form.mx <= 0 || this.form.mx > 20) {
        this.$Message.warning("MX优先级范围1-20");
        return false;
      }
      if (!this.form.ttl) {
        this.$Message.warning("请输入TLL！");
        return;
      }
      if (this.form.ttl < 600 || this.form.ttl > 604800) {
        this.$Message.warning("TLL范围600-604800");
        return false;
      }
      if (!this.form.code) {
        this.$Message.warning("请输入短信验证码！");
        return;
      }
      let data = {
        code: this.form.code,
        host: this.form.host,
        lineId: this.form.lineId,
        mx: this.form.mx,
        ttl: this.form.ttl,
        type: this.form.type,
        value: this.form.value,
      };

      this.loading = true;
      try {
        let res = "";
        if (this.type === 0) {
          data.domainId = this.data.id;
          res = await resolutionSave(data);
        } else {
          data.id = this.data.id;
          res = await resolutionModify(data);
        }
        this.loading = false;
        if (res.code === 200 && res.result) {
          this.$emit("submit-success", (res) => {
            if (res) {
              this.onCancel();
              this.$Message.success("添加成功！");
            }
          });
        }
        this.$refs.smsBtn.reset();
      } catch (error) {
        this.loading = false;
        this.$refs.smsBtn.reset();
        console.log(error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.col {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 20px;
  .name {
    color: #333333;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .label {
    color: #999999;
  }
}
.name.required {
  &::before {
    content: "*";
    color: #ed1d33;
    margin-right: 5px;
  }
}
.upload-section {
  width: 200px;
  height: 122px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 45px;
    height: 35px;
  }
}
.icon2 {
  border: 1px dashed #dcdee2;
  position: relative;
  width: 200px;
  height: 122px;
  background-size: cover;
  background-position: center;
  .close {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
}
.row {
  display: flex;
  align-items: center;
}
.fixed {
  top: 51px;
  bottom: 64px;
  transform: translateX(-50%);
  height: auto;
}
</style>
<style lang="less" scoped>
/deep/.height45 {
  .ivu-input[disabled] {
    color: #333;
  }
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
</style>
